import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'

interface ConfirmationModalState {
  display: boolean,
  taskId: number
  labelId: number
  labelGroupId: number
  callback: (taskId: number, labelGroupId: number, labelId: number, persistence: boolean) => void
}

interface Props {
  confirmationModalState: ConfirmationModalState
  closeCallback: VoidFunction
}

const PersistenceConfirmationModal: FC<Props> = (props) => {
  const {
    confirmationModalState,
    closeCallback,
  } = props

  const [isDeletePersistence, setIsDeletePersistence] = useState<boolean>(true)
  const [scrollY, setScrollY] = useState<number>(0)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (confirmationModalState.display) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [confirmationModalState.display])

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${confirmationModalState.display || 'none'}`} style={{ width: "500px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  仕分けの削除
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                <p>
                  仕分けを削除します。
                </p>
                <p>
                  自動仕分け条件も削除しますか？
                </p>
                <p>
                  (今後はこの条件で自動仕分けされなくなります)
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    marginTop: "24px",
                    width: "fit-content",
                  }}
                  onClick={() => setIsDeletePersistence(!isDeletePersistence)}
                  role="none"
                >
                  <FontAwesomeIcon
                    icon={['far', isDeletePersistence ? 'check-square' : 'square']}
                    style={{
                      fontSize: "20px",
                      color: isDeletePersistence ? "#008000" : "#666666",
                    }}
                  />
                  自動仕分け条件も削除します
                </div>
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  キャンセル
                </button>
                <button
                  type="button"
                  className="button delete"
                  onClick={() => {
                    confirmationModalState.callback(
                      confirmationModalState.taskId,
                      confirmationModalState.labelGroupId,
                      confirmationModalState.labelId,
                      isDeletePersistence,
                    )
                    closeCallback()
                  }}
                >
                  削除
                </button>
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
    </>
  )
}

export default PersistenceConfirmationModal
